/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pHead.vue?vue&type=template&id=24fc2424"
import script from "./pHead.vue?vue&type=script&lang=js"
export * from "./pHead.vue?vue&type=script&lang=js"
import style0 from "./pHead.vue?vue&type=style&index=0&id=24fc2424&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports